import { Empty } from 'antd'
import React from 'react'

function TableEmptyContent() {
    return (
        <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No Records Found"
        />
    )
}

export default TableEmptyContent